interface AudioFingerprint {
  audioContext: boolean
  sampleRate: number
  channels: number
  threshold: number
  knee: number
  ratio: number
  attack: number
  release: number
}

export function getAudioFingerprint(): AudioFingerprint | null {
  try {
    const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)()
    const oscillator = audioContext.createOscillator()
    const analyser = audioContext.createAnalyser()
    const compressor = audioContext.createDynamicsCompressor()

    oscillator.connect(compressor)
    compressor.connect(analyser)

    return {
      audioContext: true,
      sampleRate: audioContext.sampleRate,
      channels: analyser.channelCount,
      threshold: compressor.threshold.value,
      knee: compressor.knee.value,
      ratio: compressor.ratio.value,
      attack: compressor.attack.value,
      release: compressor.release.value
    }
  } catch (e) {
    console.error('Audio fingerprint failed:', e)
    return null
  }
}
